module.exports = __webpack_public_path__ + "img/1587190411.e30ad3bc.jpg";